export const whitePaperLightTheme = {
  '--white-paper-bgc-1': '#f8f8f8',
  '--white-paper-bgc-2': 'linear-gradient(180deg, #ab2c85, #12adc1)',
  '--white-paper-bgc-3': '#fff',
  '--white-paper-font-c-1': '#333',
  '--white-paper-font-c-2': '#333',
  '--white-paper-font-c-3': '#65D5FF',
  '--white-paper-font-c-4': '#666',
  '--white-paper-font-c-5': '#fff',
  '--white-paper-font-c-6': '#9fa7b3',
  '--white-paper-font-c-7': '#999',
  '--white-paper-border-c-1': '#3b3e49',
}
export const whitePaperDarkTheme = {
  '--white-paper-bgc-1': '#23262f',
  '--white-paper-bgc-2': 'linear-gradient(180deg, #ab2c85, #12adc1)',
  '--white-paper-bgc-3': '#0C102A',
  '--white-paper-font-c-1': '#fff',
  '--white-paper-font-c-2': '#9fa7b3',
  '--white-paper-font-c-3': '#65D5FF',
  '--white-paper-font-c-4': '#9fa7b3',
  '--white-paper-font-c-5': '#fff',
  '--white-paper-font-c-6': '#9fa7b3',
  '--white-paper-font-c-7': '#9fa7b3',
  '--white-paper-border-c-1': '#3b3e49',
}
